export default __webpack_public_path__ + "static/Kokall-popup-Gesloten_Vakantie-8428d4d31a48d566e67af741a9a3897c.png";